import Mulberry1 from "../../../media/mulberry/mulberry1.png";
import Mulberry2 from "../../../media/mulberry/mulberry2.png";
import Mulberry3 from "../../../media/mulberry/mulberry3.png";
import Mulberry4 from "../../../media/mulberry/mulberry4.png";
import Mulberry5 from "../../../media/mulberry/mulberry5.png";
import Mulberry6 from "../../../media/mulberry/mulberry6.png";

const mulberryimages = [
  Mulberry1,
  Mulberry2,
  Mulberry3,
  Mulberry4,
  Mulberry5,
  Mulberry6,
];

export default mulberryimages;
